import React, { useState } from 'react';

import { PropTypes } from 'prop-types';

import { saveAs } from 'file-saver';
import moment from 'moment';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setAlarm } from '../../../redux/actions/general';
import CsvButtonTemplate from './CsvButtonTemplate';

function mergeCsvParts(parts) {
   const nonEmpty = parts.filter((p) => p && p.trim().length > 0);
   if (nonEmpty.length === 0) return '';

   const firstLines = nonEmpty[0].split('\n');
   const header = firstLines[0];
   const firstRows = firstLines.slice(1).filter((l) => l.trim());
   const seen = new Set(firstRows);
   const result = [...firstRows];

   for (let i = 1; i < nonEmpty.length; i++) {
      nonEmpty[i]
         .split('\n')
         .slice(1)
         .forEach((line) => {
            if (line.trim() && !seen.has(line)) {
               seen.add(line);
               result.push(line);
            }
         });
   }

   return [header, ...result].join('\n');
}

function CsvExportSplitApiButton({ urls, header, cancelToken, filename, heightInPx, inputStyle }) {
   const [startRequest, setStartRequest] = useState(false);
   const dispatch = useDispatch();

   useQuery({
      queryKey: ['csvSplitDownload', ...urls, startRequest],
      queryFn: () =>
         Promise.all(
            urls.map((url) =>
               axios({
                  method: 'get',
                  url: `${url}&format=csv`,
                  headers: header,
                  cancelToken: cancelToken.token,
               }).then((res) => res.data),
            ),
         ),
      enabled: startRequest,
      onSuccess: (parts) => {
         setStartRequest(false);
         const blob = new Blob([mergeCsvParts(parts)], { type: 'text/csv;charset=utf-8' });
         saveAs(blob, `${filename}_${moment.utc().format().replace(':', '_')}.csv`);
      },
      onError: (err) => {
         setStartRequest(false);
         dispatch(setAlarm('danger', err));
      },
      refetchOnWindowFocus: false,
   });

   return (
      <CsvButtonTemplate
         clickHandler={() => setStartRequest(true)}
         heightInPx={heightInPx}
         isLoading={startRequest}
         inputStyle={inputStyle}
      />
   );
}

CsvExportSplitApiButton.propTypes = {
   urls: PropTypes.arrayOf(PropTypes.string).isRequired,
   header: PropTypes.object,
   cancelToken: PropTypes.object,
   filename: PropTypes.string,
   heightInPx: PropTypes.number,
   inputStyle: PropTypes.bool,
};

CsvExportSplitApiButton.defaultProps = {
   heightInPx: 19,
   inputStyle: false,
};

export default CsvExportSplitApiButton;
